import { render, staticRenderFns } from "./FooterSocialIcon.vue?vue&type=template&id=f17226d4&scoped=true&"
import script from "./FooterSocialIcon.vue?vue&type=script&lang=ts&"
export * from "./FooterSocialIcon.vue?vue&type=script&lang=ts&"
import style0 from "./FooterSocialIcon.vue?vue&type=style&index=0&id=f17226d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f17226d4",
  null
  
)

export default component.exports